import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CitylokApiService } from 'src/app/services/citylok-api.service';

@Component({
  selector: 'app-dialog-unlock-seats',
  templateUrl: './dialog-unlock-seats.component.html',
  styleUrls: ['./dialog-unlock-seats.component.scss'],
})
export class DialogUnlockSeatsComponent implements OnInit {

  groups: any[] = [];
  selectedIds: Set<number> = new Set();
  loading: boolean = true;
  unlocking: boolean = false;
  error: string = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { sessionId: number },
    private dialogRef: MatDialogRef<DialogUnlockSeatsComponent>,
    private citylokService: CitylokApiService
  ) {}

  ngOnInit(): void {
    this.citylokService.getSessionBlockedSeatGroups(this.data.sessionId).subscribe({
      next: (res) => {
        this.groups = (res?.data || []).filter((g: any) => g.seats_count > 0);
        this.loading = false;
      },
      error: () => {
        this.error = 'No se pudieron cargar los grupos de bloqueo.';
        this.loading = false;
      }
    });
  }

  toggle(id: number) {
    if (this.selectedIds.has(id)) {
      this.selectedIds.delete(id);
    } else {
      this.selectedIds.add(id);
    }
  }

  isSelected(id: number): boolean {
    return this.selectedIds.has(id);
  }

  selectAll() {
    if (this.allSelected) {
      this.selectedIds.clear();
    } else {
      this.groups.forEach(g => this.selectedIds.add(g.id));
    }
  }

  get allSelected(): boolean {
    return this.groups.length > 0 && this.selectedIds.size === this.groups.length;
  }

  unlock() {
    if (this.selectedIds.size === 0) return;
    this.unlocking = true;
    const ids = Array.from(this.selectedIds);

    this.citylokService.unlockMultipleBlockedSeats(this.data.sessionId, ids).subscribe({
      next: (res) => {
        this.unlocking = false;
        this.dialogRef.close(res?.data || null);
      },
      error: () => {
        this.unlocking = false;
        this.error = 'Error al desbloquear los asientos. Inténtalo de nuevo.';
      }
    });
  }

  cancel() {
    this.dialogRef.close(null);
  }
}
